import * as React from 'react';
import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';

const metricListVariants = cva('flex flex-col', {
  variants: {
    space: {
      default: 'gap-9',
      sm: 'gap-3'
    }
  },
  defaultVariants: {
    space: 'default'
  }
});

const MetricList = React.forwardRef(({ space, className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(metricListVariants({ space }), className)}
    {...props}
  />
));
MetricList.displayName = 'MetricList';

export { MetricList };
